// Mock data for Gorito Fine Arts Clone

export const siteConfig = {
  name: "Gorito Fine Arts",
  tagline: "Original Paintings and Fine Art Prints",
  description: "I'm an artist located in Sweden offering my original paintings, fine art prints, and merch for the European and US markets.",
  announcement: "Introducing Gorito Art Tees",
  announcementLink: "/collections/t-shirts"
};

export const collections = [
  {
    id: "1",
    name: "Water Meditation Series",
    slug: "water-meditation",
    description: "A Collection of Images Depicting Meditation in Water.",
    image: "https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=1920&q=80",
    featured: true
  },
  {
    id: "2",
    name: "War Series",
    slug: "war-collection",
    description: "A series of images inspired by the horrors of war.",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=1920&q=80",
    featured: true
  },
  {
    id: "3",
    name: "Portrait Series",
    slug: "portraits",
    description: "A collection of iconic personalities from the world of art, music, and screen.",
    image: "https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=1920&q=80",
    featured: true
  },
  {
    id: "4",
    name: "Kaleidoscope Series",
    slug: "kaleidoscope",
    description: "A collection of meditative kaleidoscopes to inspire a mindful home or office.",
    image: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?w=1920&q=80",
    featured: true
  },
  {
    id: "5",
    name: "T-Shirts",
    slug: "t-shirts",
    description: "Wearable art for everyday expression.",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=1920&q=80",
    featured: false
  }
];

export const artworks = [
  {
    id: "1",
    title: "Siren's Crimson Call - The Seduction of the Summon",
    slug: "sirens-crimson-call",
    collectionId: "2",
    price: 108.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=800&q=80",
    description: "A powerful exploration of temptation and allure.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  },
  {
    id: "2",
    title: "Adele Portrait",
    slug: "adele-portrait",
    collectionId: "3",
    price: 108.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=800&q=80",
    description: "A vibrant portrait capturing the essence of the iconic singer.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  },
  {
    id: "3",
    title: "Ariana Grande Portrait",
    slug: "ariana-grande-portrait",
    collectionId: "3",
    price: 108.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1578926375605-eaf7559b1458?w=800&q=80",
    description: "Pop culture meets fine art in this stunning portrait.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  },
  {
    id: "4",
    title: "Avicii Portrait",
    slug: "avicii-portrait",
    collectionId: "3",
    price: 108.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1549490349-8643362247b5?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1578926288207-a90a5366759d?w=800&q=80",
    description: "A tribute to the legendary music producer.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  },
  {
    id: "5",
    title: "Blondie Portrait",
    slug: "blondie-portrait",
    collectionId: "3",
    price: 108.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1549887534-1541e9326642?w=800&q=80",
    description: "Punk rock icon immortalized in vibrant colors.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  },
  {
    id: "6",
    title: "Bob Dylan Mens Boxy Tee",
    slug: "bob-dylan-boxy-tee",
    collectionId: "5",
    price: 48.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&q=80",
    description: "Premium quality tee featuring Bob Dylan artwork.",
    sizes: ["S", "M", "L", "XL"],
    inStock: true
  },
  {
    id: "7",
    title: "Bob Dylan Portrait",
    slug: "bob-dylan-portrait",
    collectionId: "3",
    price: 108.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1578926288207-a90a5366759d?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800&q=80",
    description: "The voice of a generation captured in fine art.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  },
  {
    id: "8",
    title: "Ocean Dreams",
    slug: "ocean-dreams",
    collectionId: "1",
    price: 128.00,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=800&q=80",
    hoverImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
    description: "Immerse yourself in the tranquil depths.",
    sizes: ["Small (11x14)", "Medium (18x24)", "Large (24x36)"],
    inStock: true
  }
];

export const blogPosts = [
  {
    id: "1",
    title: "Ziggy Stardust's Glow-Up: My David Bowie Portrait and 4 Other Iconic Oddballs That'll Crash Your Wall Party",
    slug: "ziggy-stardust-glow-up",
    excerpt: "Yo, vinyl vampires and vibe curators—slide back into the Gorito.com blog, where I don't just slap paint on canvas or move pixels up and down; we spike it with espresso...",
    content: "Full article content here...",
    date: "October 20, 2025",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&q=80",
    author: "Gorito"
  },
  {
    id: "2",
    title: "Scroll-Stopping Secret: The Perfect Art Print Size to Wow Your Collection in the US and Europe!!",
    slug: "perfect-art-print-size",
    excerpt: "Hey, art collectors! You're on the hunt for that jaw-dropping print to elevate your living room wall, but you're drowning in a sea of cryptic sizes—A4, B2, C3, oh my!...",
    content: "Full article content here...",
    date: "July 2, 2025",
    image: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=800&q=80",
    author: "Gorito"
  },
  {
    id: "3",
    title: "The Art of Color: How Bold Palettes Transform Emotion",
    slug: "art-of-color",
    excerpt: "Colors speak louder than words. In this deep dive, we explore how vibrant hues can transform not just a room, but your entire mood...",
    content: "Full article content here...",
    date: "June 15, 2025",
    image: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?w=800&q=80",
    author: "Gorito"
  }
];

export const aboutContent = {
  title: "About Gorito Fine Arts",
  bio: "I'm an artist based in Sweden with a passion for creating vibrant, expressive artwork that captures the essence of iconic personalities and abstract concepts. My work spans across multiple mediums including digital art, paintings, and wearable merchandise.",
  image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=800&q=80",
  story: "My artistic journey began over a decade ago, inspired by the bold colors of pop art and the emotional depth of expressionism. Each piece I create is a labor of love, designed to evoke emotion and spark conversation.",
  mission: "To bring fine art into everyday spaces, making beautiful, thought-provoking artwork accessible to collectors worldwide."
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Collections", path: "/collections", hasDropdown: true },
  { name: "About", path: "/about", hasDropdown: true },
  { name: "News", path: "/news" },
  { name: "Contact", path: "/contact" }
];
